import produce from 'immer';
import { isEmpty } from 'lodash';
import { UseMutationResult } from 'react-query';

import { Contacts } from '~/types/Contacts';
import { IndividualRowType } from '~/types/IndividualRowType';
import { Person } from '~/types/Person';
import { contactObjCreation, getUpdatedAuthorizedRepresentativeDataSync, getUpdatedContact } from './contacts';

export const getAuthorizedRepresentativesData = (
  draftData: Person[],
  onChange: (value: Person[]) => void,
  onEdit: (uid: string) => void,
  sourceOfEditing: string,
  contactMutation: UseMutationResult<any, unknown, any, void>,
  allContacts: Contacts[],
): IndividualRowType[] => {
  if (Object.entries(draftData).length < 1 || draftData.length < 1) return [];
  const updatedData = getUpdatedAuthorizedRepresentativeDataSync(draftData, allContacts, sourceOfEditing);

  const authorizedRepresentative: IndividualRowType[] = updatedData?.map((item) => {
    return {
      ...item,
      uid: item.uid,
      firstName: item.firstName,
      lastName: item.lastName,
      hasPassport: !isEmpty(item?.passport?.files),
      hasEmiratesId: !isEmpty(item?.emiratesId?.files),
      onEdit: () => item?.uid && onEdit(item.uid),
      onDelete: async () => {
        const updatedContact = await getUpdatedContact(item);
        const toDeleteIndividual = contactObjCreation(updatedContact, {
          type: 'DELETE',
          role: 'authorizedRepresentative',
        });
        contactMutation?.mutate(toDeleteIndividual);
        onChange(
          produce(draftData, (draft: Person[]) => {
            draft = draft.filter((a) => a?.uid !== item?.uid);
            return draft;
          }),
        );
      },
    };
  });

  return authorizedRepresentative;
};
